import React from "react";
import { Box, Paper, Typography, useTheme, List, ListItem } from "@mui/material";

const AboutCard = ({ title, list }) => {
  const theme = useTheme();
  const items = Array.isArray(list) ? list : [];
  if (!items.length) return null;

  return (
    <Paper
      sx={{
        p: "1.25rem 1.5rem",
        mb: "1rem",
        backgroundColor: theme.palette.background.alt,
      }}
    >
      <Typography
        variant="h5"
        fontWeight={700}
        color={theme.palette.secondary.main}
        sx={{ mb: "0.5rem" }}
      >
        {title}
      </Typography>
      <List sx={{ py: 0 }}>
        {items.map((item) => (
          <ListItem key={`${title}:${item}`} disablePadding sx={{ py: "0.2rem" }}>
            <Box
              component="span"
              sx={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                backgroundColor: theme.palette.text.secondary,
                mr: "0.65rem",
                flexShrink: 0,
              }}
            />
            <Typography variant="body1" color={theme.palette.text.primary}>
              {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default AboutCard;
